import { DefaultService } from '@/services/DefaultService';

export default class UsuarioObjetivoVendaService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env);
    }

    getAll(dtIni, dtFim) {
        return this._http.get(`${this._env}/vendas/objetivovenda.json?inicio=${dtIni}&fim=${dtFim}`, this._headers)
            .then(res => res.body, this.handleError);
    }

    save(list) {
        return this._http.post(`${this._env}/vendas/objetivovenda`, list, this._headers)
            .then(res => res.body, this.handleError);
    }

    findAll(situacao, mesInicial, mesFinal, page = 0, limit = 50, order = 'asc', sort = 'descricao', ...param) {
        return this._http.get(encodeURI(`${this._env}/vendas/objetivovenda/findAll.json?mesInicial=${mesInicial}&mesFinal=${mesFinal}&page=${page}&limit=${limit}&order=${order}&situacao=${situacao}&sort=${sort}&param=${param}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findObjetivoVendaHeader(mesInicial, mesFinal, search) {
        return this._http.get(encodeURI(`${this._env}/vendas/objetivovenda/findObjetivoVendaHeader.json?mesInicial=${mesInicial}&mesFinal=${mesFinal}&param=${search}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}